/** How far ahead a row warns about an expiry, when no server window is to hand. */
export const DEFAULT_EXPIRY_WINDOW_DAYS = 30

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/

/**
 * The parser returns dates as bare `YYYY-MM-DD`, which `new Date` reads as UTC
 * midnight — a day earlier than it says everywhere west of UTC, which is all of
 * this product's users. A timestamp carries its own offset and is left alone.
 */
function toDate(value: string): Date {
  if (!DATE_ONLY.test(value)) return new Date(value)
  const [year, month, day] = value.split('-').map(Number)
  return new Date(year, month - 1, day)
}

export function formatDate(value: string | null | undefined) {
  if (!value) return '—'
  return toDate(value).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

export function formatFileSize(bytes: number | null | undefined) {
  if (bytes === null || bytes === undefined) return '—'
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

/** The two tones the vault's banner uses, so a row and the banner never disagree. */
export function expiryClass(
  dateExpiration: string | null,
  windowDays: number = DEFAULT_EXPIRY_WINDOW_DAYS
): string {
  if (!dateExpiration) return 'text-muted-foreground'
  // Compared against local midnight, so a document expiring today is "soon" and
  // not already expired.
  const startOfToday = new Date()
  startOfToday.setHours(0, 0, 0, 0)
  const days = (toDate(dateExpiration).getTime() - startOfToday.getTime()) / 86_400_000
  if (days < 0) return 'text-(--red-text) font-medium'
  if (days <= windowDays) return 'text-(--amber-text) font-medium'
  return 'text-muted-foreground'
}
